import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getTalkingPointDetail = async (id) => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `/briefs/talking-points/${id}`,
  });

  return data?.data;
};

export default getTalkingPointDetail;
